<div class="server-unavailable">
  <div class="server-unavailable__icon">
    <i class="pi pi-exclamation-triangle"></i>
  </div>
  <h1 class="server-unavailable__title">{{ 'serverError.title' | translate }}</h1>
  <p class="server-unavailable__message">{{ 'serverError.message' | translate }}</p>
  <a
    class="swd-button primary"
    routerLink="/">
    {{ 'serverError.returnHome' | translate }}
  </a>
</div>
